<template>
    <!-- confirmation modal -->
    <b-modal 
        ref="modal"
        :id="computedModalId" 
        :title="title" 
        centered>
        <p>{{ description }}</p>
        <template #modal-footer>
            <b-button
                :variant="primaryVariant"
                @click="onConfirm" :disabled="isLoading">
                تأكيد
            </b-button>
            <button class="btn btn-outline-primary" @click="onCancel" :disabled="isLoading">
                إلغاء
            </button>
        </template>
    </b-modal>

</template>

<script>
export default {
    name: 'ConfirmationModal',
    props: {
        handleConfirmation: {
            type: Function,
            required: true
        },
        handleCancel: {
            type: Function,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        primaryVariant: {
            type: String,
            required: false,
            default: 'primary'
        },
        modalId: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        computedModalId() {
            return this.modalId || `confirmation-modal-${this._uid || Math.random().toString(36).substr(2, 9)}`;
        }
    },
    data() {
        return {
            isLoading: false
        }
    },
    methods: {
        openModal() {
            this.$refs.modal.show()
        },
        closeModal() {
            this.$refs.modal.hide()
        },
        async onCancel() {
            this.isLoading = true
            try {
                await this.handleCancel()
            } finally {
                this.isLoading = false
                this.closeModal()
            }
        },
        async onConfirm() {
            this.isLoading = true
            try {
                await this.handleConfirmation()
            } finally {
                this.isLoading = false
                this.closeModal()
                // emit refresh
                this.$emit('refreshData')
            }
        }
    }
}
</script>
